import { BrandProp } from "@mojo/types";
import React from "react";
import useMeasure from "../../utils/useMeasure";
import { VanillaNav } from "../styles/base.css";
import { useTemplate } from "../useTemplate";
import { Logo } from "./Logo";

type BasicNavProps =
  & {
    variant?: "transparent" | "white";
    width?: "full" | "limited";
    /**
     * Will be rendered on the right side, opposite to the logo
     */
    rightSlot?: React.ReactNode;
  }
  & React.HTMLAttributes<HTMLDivElement>
  & BrandProp;

/**
 * BasicNav contains simple styles and a logo.
 * It does not include any auth components.
 */
export const BasicNav = ({
  variant = "transparent",
  brand = "Mojo",
  width = "full",
  rightSlot,
  ...props
}: BasicNavProps) => {
  const { setNavHeight } = useTemplate();
  const [ref, { height }] = useMeasure();

  React.useLayoutEffect(() => {
    setNavHeight(height);
  }, [height]);

  return (
    <nav
      {...props}
      className={`mojo__nav ${VanillaNav({ variant, width })} ${props.className || ""}`}
      ref={ref}
    >
      <Logo brand={brand} />
      {Boolean(rightSlot) && <div>{rightSlot}</div>}
    </nav>
  );
};
